
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/mtf",
      function () {
        return require("private-next-pages/asset/mtf.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/mtf"])
      });
    }
  